import React, { FC } from 'react';
import './NotificationsHeaderTitle.scss';
import { useTranslation } from 'react-i18next';

export const NotificationsHeaderTitle: FC = () => {
  const { t } = useTranslation();

  return <div className="NotificationsHeaderTitle">{t('Notifications')}</div>;
};
